"use client";

import { useDealerProfileTracking } from "@/app/helpers/dealerProfileTracking";

// Retry only existing queued events. This component never starts a profile.
export default function DealerTrackingRetry() {
  useDealerProfileTracking();
  return null;
}
